<template>
	<div class="mdc-textfield" :class="classes">
		<slot></slot>
	</div>
</template>

<script>
	// Dependencies
	import { MDCTextField } from '@material/textfield/dist/mdc.textfield'

	// Export
	export default {
		name: 'textField',
		data: () => ({
			classes: '',
			foundation: null,
		}),
		mounted() {
			this.$nextTick(() => {
				setTimeout(() => {
					new MDCTextField(this.$el)
				}, 250)
			})
		},
	}
</script>

<style scoped lang="scss">
	@import '@material/textfield/mdc-text-field';

	.mdc-textfield {
		will-change: opacity, color !important;

		&--fullwidth {
			position: relative;
		}

		&__label {
			background-color: transparent !important;
		}

		&--textarea {
			border-color: rgba(0,0,0,0.3);
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/TextField.vue